import validate from 'validate.js';
import dayjs from 'dayjs';

import { addError, removeError, fieldIsValid } from '../../../node_modules/glo-shared-js/utils/validation';
import { throttle } from '../../../node_modules/glo-shared-js/utils/helpers';

(function() {
	if (document.getElementById('gift-form')) {
		var browserNavigation = window.performance.getEntriesByType('navigation')[0];
		// Check if page is loaded from user hitting the back button to land back on the gift page and will reload the page.
		// This is used because the radio buttons and scheduler values do not persist to the following page on Chrome
		if (browserNavigation && String(browserNavigation.type) === 'back_forward') {
			window.location.reload();
		}

		var checkStepOne = function(field) {
			// Check if amount, name and email are filled out
			var amount = document.querySelector('input[name="amount"]:checked') ? document.querySelector('input[name="amount"]:checked').value : null;
			var isScheduled = document.querySelector('input[name="schedule"]:checked').value === 'scheduled';
			var values = {
				amount: amount,
				recipientName: document.getElementById('gift-purchase__input-name').value,
				recipientEmail: document.getElementById('gift-purchase__input-email').value,
				sendDate: isScheduled ? document.getElementById('datepicker').value : null
			};
			var constraints = {
				amount: {
					presence: {
						message: '^Please choose an amount'
					}
				},
				recipientName: {
					presence: {
						message: '^Please enter a name'
					}
				},
				recipientEmail: {
					presence: {
						message: '^Please enter an email address'
					},
					email: {
						message: '^Please enter a valid email address'
					}
				}
			};

			if (isScheduled) {
				validate.validators.checkSendDate = function(value, message) {
					if (!value) return;

					if (!dayjs(value).toISOString()) {
						return message.validDate;
					} else if (!dayjs(value).isAfter(new Date())) {
						return message.inFuture;
					}
				};

				constraints.sendDate = {
					checkSendDate: {
						validDate: '^Please select a valid date from the calendar.',
						inFuture: '^Please choose a date in the future.'
					}
				};
			}

			var validationErrors = validate(values, constraints);

			// Let's first remove the errors on the current field
			removeError(field);

			// If there are validation errors,
			// add appropriate error states and messaging
			// and ensure the "next" button is disabled
			if (validationErrors) {
				document.querySelector('.btn--next').classList.add('btn--disabled');

				for (let key in validationErrors) {
					var err = validationErrors[key];

					if (field) {
						// If we're validating a specific field, only show errors for that field
						if (field === key) addError(key, err);
					} else {
						// Otherwise, show errors for all fields
						// (this would run when user tries to click the disabled "next" button)
						if (key === 'amount' && !document.querySelectorAll('.form-error--amount').length) {
							var errorElement = document.createElement('span');
							errorElement.classList = 'form-error form-error--amount';
							errorElement.innerText = 'Please specify an amount.';
							document.querySelector('.gift-purchase__prices').prepend(errorElement);
						} else {
							addError(key, err);
						}
					}
				}
			} else {
				// Otherwise, if everything checks out, let's enable the "next" button
				document.querySelector('.btn--next').classList.remove('btn--disabled');
			}
		};

		new Pikaday({
			field: document.getElementById('datepicker'),
			format: 'MM/DD/YYYY',
			disableDayFn: function(dateObj) {
				return !dayjs(dateObj).isAfter(new Date());
			},
			onSelect: function() {
				checkStepOne('sendDate');
			}
		});

		fieldIsValid.password = true;

		// Handle click event on the "amount" radio buttons
		document.querySelectorAll('input[name="amount"]').forEach(function(element) {
			element.addEventListener('click', function() {
				document.querySelectorAll('.gift-purchase__output-amount').forEach(function(outputAmountElement) {
					outputAmountElement.innerText = element.value;
				});
				checkStepOne('amount');
			});
		});

		document.querySelectorAll('input[name="schedule"]').forEach(function(element) {
			element.addEventListener('click', function() {
				var isScheduled = element.value === 'scheduled';
				var datepickerElement = document.getElementById('datepicker');

				datepickerElement.toggleAttribute('disabled', !isScheduled);

				if (isScheduled) datepickerElement.click();

				checkStepOne('sendDate');
			});
		});

		// Validate name and email fields while user types or clicks out of the input field
		var nameInput = document.getElementById('gift-purchase__input-name');
		var emailInput = document.getElementById('gift-purchase__input-email');
		var datepickerElement = document.getElementById('datepicker');

		var keyupEvent = throttle(function(e) {
			removeError(e.target.getAttribute('name'));
		}, 600);

		var blurEvent = function(e) {
			checkStepOne(e.target.getAttribute('name'));
		};

		nameInput.addEventListener('keyup', keyupEvent);
		emailInput.addEventListener('keyup', keyupEvent);
		datepickerElement.addEventListener('keyup', keyupEvent);

		nameInput.addEventListener('blur', blurEvent);
		emailInput.addEventListener('blur', blurEvent);
		datepickerElement.addEventListener('blur', blurEvent);

		// This is for the handling of the dropdown menu users will see if they're logged in
		// that allows them to choose between using their current card or a new one
		if (document.getElementById('gift-purchase__payment-type')) {
			document.getElementById('gift-purchase__payment-type').addEventListener('change', function() {
				document.querySelector('.gift-purchase__cc-form').classList.toggle('hide', this.value !== 'other');
				document.querySelector('.gift-purchase__purchase-btn').classList.toggle('hide', this.value === 'other');

				removeError('general');
			});
		}

		document.querySelector('.btn--next').addEventListener('click', function(e) {
			e.preventDefault();
			// Handle click event on the enabled "next" button
			if (!e.target.classList.contains('btn--disabled')) {
				var el = document.querySelector('.gift-purchase__page:not(.hide)');
				var pxToScroll = el.getBoundingClientRect().top + window.scrollY;
				var sendDate = datepickerElement.value;
				var currentDate = dayjs(new Date()).format('MM/DD/YYYY');
				var outputDateElement = document.querySelector('.gift-purchase__output-date');

				// Update the copy in the following step to include information about the
				// gift recipient that was inputed in step 1
				document.querySelectorAll('.gift-purchase__output-name').forEach(function(element) {
					element.innerText = document.querySelector('input[name="recipientName"]').value;
				});

				document.querySelectorAll('.gift-purchase__output-email').forEach(function(element) {
					element.innerText = document.querySelector('input[name="recipientEmail"]').value;
				});

				document.querySelectorAll('.gift-purchase__output-message').forEach(function(element) {
					element.innerText = document.querySelector('#gift-purchase__input-message').value;
				});

				document.querySelector('.gift-purchase__page[data-step="1"]').classList.toggle('hide');
				document.querySelector('.gift-purchase__page[data-step="2"]').classList.toggle('hide');

				if (sendDate) {
					outputDateElement.innerText = 'Delivers on ' + sendDate + ' to ';
				} else {
					outputDateElement.innerText = 'Delivers on ' + currentDate + ' to ';
				}

				// Animate to element (this is especially valuable in mobile)
				window.scroll({
					top: pxToScroll,
					behavior: 'smooth'
				});
			} else {
				// Handle click event on the "disabled" "next" button
				checkStepOne();
			}
		});

		// Go back to the first step to edit choices
		document.querySelector('.gift-purchase__edit-link').addEventListener('click', function() {
			document.querySelector('.gift-purchase__page[data-step="1"]').classList.toggle('hide');
			document.querySelector('.gift-purchase__page[data-step="2"]').classList.toggle('hide');
		});
	}

	// Tooltips - Currently these only exist on the /gift page, hence this code living in this file
	document.querySelectorAll('.tooltip-info').forEach(function(iconElement) {
		const tooltipId = iconElement.getAttribute('data-tooltip-id');
		const tooltipElement = document.querySelector(`.tooltip[data-tooltip-id="${tooltipId}"]`);

		iconElement.append(tooltipElement);

		iconElement.addEventListener('click', function() {
			iconElement.classList.toggle('tooltip-info--active');
			tooltipElement.classList.toggle('tooltip--hidden');

			if (iconElement.classList.contains('tooltip-info--active')) {
				// reset content positioning
				tooltipElement.style.width = '';
				tooltipElement.style.left = '';

				placeTooltip(tooltipElement);
			}
		});
	});

	// Change tooltip position then resize
	window.onresize = () => {
		const tooltipElements = document.querySelectorAll('.tooltip:not(.tooltip--hidden)');
		tooltipElements.forEach(function(tooltipElement) {
			placeTooltip(tooltipElement);
		});
	};

	function placeTooltip(tooltipElement) {
		const windowWidth = window.innerWidth;
		const contentInnerWidth = tooltipElement.clientWidth;
		const contentMargin = 20;
		const scrollBuffer = 75;
		let contentOuterWidth = tooltipElement.offsetWidth;
		let offset, tooltipRect;

		// ensure content fits window width
		if (contentOuterWidth > windowWidth) {
			tooltipElement.style.width = windowWidth - (contentMargin * 2) - (contentOuterWidth - contentInnerWidth);
		}

		tooltipRect = tooltipElement.getBoundingClientRect();
		contentOuterWidth = tooltipElement.outerWidth;
		offset = {
			top: tooltipRect.top + window.scrollY,
			left: tooltipRect.left + window.scrollX,
		};

		// ensure left edge is on screen
		if (offset.left < 0) {
			tooltipElement.style.left = (tooltipElement.offsetLeft - offset.left + contentMargin) + 'px';
		}
		// ensure right edge is on screen
		else if (offset.left + contentOuterWidth > windowWidth) {
			tooltipElement.style.left = (tooltipElement.offsetLeft - ((offset.left + contentOuterWidth) - windowWidth) - contentMargin) + 'px';
		}

		// update the values
		tooltipRect = tooltipElement.getBoundingClientRect();
		offset = {
			top: tooltipRect.top + window.scrollY,
			left: tooltipRect.left + window.scrollX,
		};

		// scroll tooltip into view
		if (window.scrollY > offset.top - scrollBuffer) {
			window.scroll({
				top: offset.top - scrollBuffer,
				behavior: 'smooth'
			});
		}
	}
})();
